import * as types from 'common/types'
import CustomLoginInterface from 'common/types/entities/CustomLoginInterface'
import { match } from 'path-to-regexp'
import BaseNodeChildren from 'publisher/components/ChildrenEntities'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import useManagement, { selectors } from 'publisher/hooks/useManagement'
import React, { useEffect, useState } from 'react'
import { getBrandSettings } from 'src/publisher/api/brand-settings-api'
import { getUserData } from 'src/publisher/api/user-data-api'

type NewCustomLoginProps = {
  entity: CustomLoginInterface
}

function NewCustomLogin({ entity }: NewCustomLoginProps) {
  const isPreview = useManagement(selectors.isPreviewMode)
  const [mode, setMode] = useState(isPreview ? [entity.childIds[0]] : null)

  useEffect(() => {
    const checkPattern = (uri: string) => match(uri)(window.location.pathname)
    if (
      checkPattern('/dashboard/:locale/login') ||
      checkPattern('/:locale/login') ||
      checkPattern('/login')
    ) {
      setMode([entity.childIds[0]])
    } else if (
      checkPattern('/dashboard/:locale/registration/set-password/:token') ||
      checkPattern('/:locale/register/confirm/:token') ||
      checkPattern('/register/confirm/:token')
    ) {
      setMode([entity.childIds[1]])
    } else if (
      checkPattern('/dashboard/:locale/resetting/request') ||
      checkPattern('/:locale/restore-password') ||
      checkPattern('/reset-password')
    ) {
      setMode([entity.childIds[2]])
    } else if (
      checkPattern('/dashboard/:locale/resetting/reset/:token') ||
      checkPattern('/:locale/reset-password/:token') ||
      checkPattern('/reset-password/:token')
    )
      setMode([entity.childIds[3]])
  }, [entity.childIds])

  useEffect(() => {
    const load = async () => {
      const responseBrandSettings = await getBrandSettings()
      const responseUser = await getUserData()

      if (
        responseBrandSettings.data?.dashboardHostname ===
          window.location.hostname &&
        responseUser.data?.id
      ) {
        window.location.href = '/dashboard'
        return
      }
      if (responseUser.data?.id) {
        window.location.href = '/school'
      }
    }

    load()
  }, [])

  return (
    <StyleWrapper appearance={entity.appearance}>
      {mode && <BaseNodeChildren childIds={mode} />}
    </StyleWrapper>
  )
}

NewCustomLogin.propTypes = {
  entity: types.entity.isRequired,
}

export default NewCustomLogin
